<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-toolbar flat color="transparent" height="50" class="toolbar">
        <h3>Bảo trì - bảo dưỡng</h3>
        <v-spacer></v-spacer>
        <v-autocomplete
          box
          label="Chọn xe"
          item-text="plate"
          item-value="id"
          v-model="vehicleId"
          :items="vehicleDatasource"
          class="select-vehicle"
          width="200"
        ></v-autocomplete>
        <v-btn color="blue" @click="addDialog = true" dark fab>
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>
      <v-flex xs12 sm12 md12 lg12 v-for="(group, index) in filterdDatasource" :key="index">
        <h3 class="plate-group">{{group[0].plate}}</h3>
        <v-flex xs12 sm12 md12 lg12>
          <v-layout row wrap>
            <v-flex
              xs12
              sm6
              md4
              lg4
              xl3
              v-for="item in group "
              :key="item.intervalTask.id"
              @contextmenu.prevent="openContextMenu($event, item)"
            >
              <v-card class="card-item">
                <div class="card-content">
                  <div>
                    <div class="left">
                      <h4>{{item.intervalTask.name}}</h4>
                    </div>
                    <div class="right">
                      <div class="text-xs-center">
                        <v-menu offset-y>
                          <v-icon slot="activator" color="grey" class="action-button">more_vert</v-icon>
                          <v-list>
                            <v-list-tile
                              v-for="(m, index) in menu"
                              :key="index"
                              @click="m.click(item)"
                            >
                              <v-list-tile-title>
                                <v-icon class="menu-item-icon">{{m.icon}}</v-icon>
                                <span>{{m.title}}</span>
                              </v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </div>
                    </div>
                    <div class="clear"></div>
                  </div>
                  <div class="grey--text item-remain">
                    <div class="left">
                      <v-icon class="small-icon">access_time</v-icon>
                      <b :class="`${percentColor(item)}--text`">Dự kiến: {{remain(item)}}</b>
                    </div>
                    <div class="right"></div>
                    <div class="clear"></div>
                  </div>
                  <div class="grey--text item-remain" v-show="item.showMore">
                    <div class="left">
                      <v-icon class="small-icon">show_chart</v-icon>
                      Đi được: {{moved(item)}}
                    </div>
                    <div class="right"></div>
                    <div class="clear"></div>
                  </div>
                  <div class="grey--text item-remain" v-show="item.showMore">
                    <div class="left">
                      <v-icon class="small-icon">history</v-icon>
                      Tính từ: {{getLastExecution(item)}}
                    </div>
                    <div class="right"></div>
                    <div class="clear"></div>
                  </div>
                  <div class="grey--text item-remain" v-show="item.showMore" v-if="item.intervalTask.remark">
                    <div class="left">
                      <v-icon class="small-icon">note</v-icon>
                      {{item.intervalTask.remark}}
                    </div>
                    <div class="right"></div>
                    <div class="clear"></div>
                  </div>
                  <v-card-actions>
                    <v-progress-linear :value="calcPercent(item)" :color="percentColor(item)"></v-progress-linear>
                    <v-btn flat round @click="showMore(item)" small class="more-button">
                      <v-icon>{{ item.showMore ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                    </v-btn>
                  </v-card-actions>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
    <!-- Context Menu -->
    <vue-context ref="contextMenu">
      <v-list>
        <v-list-tile v-for="(item, index) in menu" :key="index" @click="item.click()">
          <v-list-tile-title>
            <v-icon class="menu-item-icon">{{item.icon}}</v-icon>
            <span>{{item.title}}</span>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </vue-context>
    <div class="text-xs-center">
      <v-dialog v-model="addDialog" width="480" persistent>
        <v-card>
          <v-toolbar card prominent color="grey lighten-3">
            <v-toolbar-title>Tạo lịch bảo trì</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="addDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <add @show="addDialog = $event"/>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showExecuteDate" max-width="290">
        <v-card>
          <v-date-picker v-model="executeDate"></v-date-picker>
          <v-card-actions>
            <v-btn
              color="success"
              dark
              block
              :loading="isLoading"
              @click="execute()"
            >Bảo trì vào ngày đã chọn</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteDialog" width="360">
        <v-card>
          <v-card-title class="headline">Xóa lịch bảo trì?</v-card-title>
          <v-card-text>
            <span>Thao tác này sẽ không thể phục hồi, bạn có chắc chắn muốn xóa ?</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat="flat" @click="deleteDialog = false">Hủy</v-btn>
            <v-btn color="red" flat="flat" :loading="isLoading" @click="deleteSubmit()">Xóa</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>
<script>
import Add from './Add';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { VueContext } from 'vue-context';
import * as DateTimeUtil from '@/utils/datetime';
import moment from 'moment';

export default {
  components: {
    Add,
    VueContext
  },

  data () {
    return {
      addDialog: false,
      vehicleId: '',
      selectedItem: null,
      showExecuteDate: false,
      executeDate: moment().format('YYYY-MM-DD'),
      isLoading: false,
      deleteDialog: false,
      dateTimeUtil: DateTimeUtil,
      menu: [
        {
          title: 'Thực hiện bảo trì',
          icon: 'done',
          click: item => {
            if (item) {
              this.selectedItem = item;
            }
            this.showExecuteDate = true;
          }
        },
        {
          title: 'Xóa',
          icon: 'delete',
          click: item => {
            if (item) {
              this.selectedItem = item;
            }
            this.deleteDialog = true;
          }
        }
      ]
    };
  },

  computed: {
    ...mapGetters(['maintenances', 'vehicles']),
    vehicleDatasource () {
      let items = [
        {
          plate: 'Tất cả xe',
          id: ''
        }
      ];
      this.vehicles.map(a => {
        items.push(a);
        return 0;
      });
      return items;
    },
    filterdDatasource () {
      let data = [];

      if (this.vehicleId) {
        let dataByVehicle = this.maintenances.filter(
          a => a.vehicleId === this.vehicleId
        );
        if (dataByVehicle.length > 0) {
          let sorted = dataByVehicle.sort(
            (a, b) => this.calcPercent(a) - this.calcPercent(b)
          );
          sorted.map(a => {
            a.showMore = false;
            return 0;
          });
          data.push(sorted);
        }
      } else {
        this.vehicles.map(v => {
          let dataByVehicle = this.maintenances.filter(
            a => a.vehicleId === v.id
          );
          if (dataByVehicle.length > 0) {
            let sorted = dataByVehicle.sort(
              (a, b) => this.calcPercent(a) - this.calcPercent(b)
            );
            sorted.map(a => {
              a.showMore = false;
              return 0;
            });
            data.push(sorted);
          }

          return 0;
        });
      }

      return data;
    }
  },

  watch: {
    vehicleId () {
      if (this.vehicleId) {
        let vehicle = this.vehicles.filter(a => a.id === this.vehicleId)[0];
        if (vehicle) {
          this.SET_SELECTED_VEHICLES(vehicle);
        }
      }
    }
  },

  created () {
    let vehicleIdFromQuery = this.$route.query.vehicleId;
    if (vehicleIdFromQuery) {
      this.vehicleId = vehicleIdFromQuery;
    }
  },

  methods: {
    ...mapActions([
      'getMaintenances',
      'deleteMaintenance',
      'executeMaintenance'
    ]),
    ...mapMutations(['SET_SELECTED_VEHICLES']),

    openContextMenu (event, item) {
      this.selectedItem = item;
      this.$refs.contextMenu.open(event);
    },
    calcPercent (item) {
      if (item.intervalTask.dayBased && item.intervalTask.kmBased) {
        return item.percentDay > item.percentKm
          ? 100 - item.percentDay
          : 100 - item.percentKm;
      } else {
        return item.intervalTask.kmBased
          ? 100 - item.percentKm
          : 100 - item.percentDay;
      }
    },
    percentColor (item) {
      let percent = this.calcPercent(item);
      let color = 'green';
      if (percent < 50) {
        color = 'orange';
        if (percent < 25) {
          color = 'red';
        }
      }
      return color;
    },
    remain (item) {
      let result = '';
      if (item.estimateDate) {
        if (item.remainDay > 0) {
          result += `${this.dateTimeUtil.formatSecondToYYMMDD(item.estimateDate)} (còn lại ${item.remainDay} ngày)`;
        } else if (item.remainDay === 0) {
          result += `${this.dateTimeUtil.formatSecondToYYMMDD(item.estimateDate)} (đã đến hạn)`;
        }
        else {
          result += `${this.getDate(item.remainDay)} (Đã vượt định mức ${Math.abs(item.remainDay)} ngày)`;
        }
      } else {
        result = 'Chưa xác định';
      }
      return result;
    },
    moved (item) {
      let result = '';

      if (item.intervalTask.kmBased) {
        result += `${item.intervalTask.kmInterval - item.remainKm} / ${item.intervalTask.kmInterval} km`;
      }

      if (item.intervalTask.kmBased && item.intervalTask.dayBased) {
        result += '; ';
      }

      if (item.intervalTask.dayBased) {
        result += `${item.intervalTask.dayInterval - item.remainDay} / ${item.intervalTask.dayInterval} ngày`;
      }

      return result;
    },
    getLastExecution (item) {
      return `${DateTimeUtil.formatSecondToYYMMDD(item.intervalTask.lastExecution)}`;
    },
    getDate (remainDay) {
      return moment()
        .add(remainDay, 'days')
        .format('YYYY-MM-DD');
    },
    execute () {
      let data = {
        id: this.selectedItem.intervalTask.id,
        time: DateTimeUtil.convertDateTimeToSecond2010(this.executeDate)
      };
      this.isLoading = true;
      this.executeMaintenance(data)
        .then(_ => {
          this.isLoading = false;
          this.showExecuteDate = false;
          this.getMaintenances();
          window.getApp.showMessage('Bảo trì thành công');
        })
        .catch(_ => {
          this.isLoading = false;
          window.getApp.showMessage(
            'Bảo trì thất bại, vui lòng thử lại',
            'error'
          );
        });
    },
    deleteSubmit () {
      if (this.selectedItem) {
        this.isLoading = true;
        this.deleteMaintenance(this.selectedItem.intervalTask.id)
          .then(_ => {
            this.isLoading = false;
            this.deleteDialog = false;
            this.getMaintenances().then(_ => {
              window.getApp.showMessage('Xóa thành công');
            });
          })
          .catch(_ => {
            this.isLoading = false;
            window.getApp.showMessage(
              'Xóa thất bại, vui lòng thử lại',
              'error'
            );
          });
      }
    },
    showMore (item) {
      item.showMore = !item.showMore;
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
.select-vehicle {
  margin-top: 8px !important;
}
.item-remain {
  margin-top: 10px;
}
.small-icon {
  font-size: 14pt;
  padding-right: 10px;
}
.card-content {
  padding: 8px 16px 2px 16px;
}
.action-button {
  margin-right: -10px;
}
.menu-item-icon {
  font-size: 15pt;
  padding-right: 10px;
}
.v-context {
  width: 200px !important;
}
.container {
  padding-top: 12px;
}
.remain-date {
  font-size: 12pt;
}
.more-button {
  margin-right: -10px !important;
}
.plate-group {
  padding-left: 12px;
}
.toolbar {
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/maintenance/components/Grid.vue